import { Component } from 'preact';

import style from './style.scss';

/**
 * The WindGauge component render a live wind speed gauge, which animates
 * the direction indicator as it moves around the compass.
 *
 * props:
 * - size: The width/height of the SVG
 * - windSpeed: Live wind speed value. May be a number or pre-formatted string.
 * - windBearing: Live wind bearing (numeric).
 */

class WindGauge extends Component {

	constructor(props) {
		super(props);

		this.previousBearing = null;

		// Check if the browser supports the <animateTransform> element. For browsers that do,
		// we will animate the wind arrow rotation angle. If not we will fall back to no animation at all.
		this.browserSupportsAnimateTransform = !!document.createElementNS('http://www.w3.org/2000/svg', 'animateTransform').beginElement;
	}

	componentDidUpdate() {
		if (this.browserSupportsAnimateTransform) {
			this.animateTransformElement.beginElement();
		}
	}

	render(props) {

		const { size, windSpeed, windBearing } = props;
		const halfSize = 0.5 * size;
		const margin = 20;
		const labelSpacing = 9.5;
		const radius = halfSize - margin;

		// Define the direction indicator path
		const indicatorSize = 20;
		const indicatorY0 = halfSize - radius + 0.5 * indicatorSize + 3;
		const indicatorY1 = indicatorY0 - indicatorSize;
		const indicatorX0 = halfSize - indicatorSize * 0.4;
		const indicatorX1 = halfSize + indicatorSize * 0.4;

		const indicatorPath = `M${indicatorX0},${indicatorY1} L${indicatorX1},${indicatorY1} L${halfSize},${indicatorY0} L${indicatorX0},${indicatorY1}`;

		// Angle to rotate the indicator to and from
		let rotateFromAngle = this.previousBearing === null ? windBearing : this.previousBearing;
		let rotateToAngle = windBearing;

		// We are working with a circular range. So when rotating from 350 deg to 10 deg, the natural
		// animation is to rotate through the 0 deg point (N), not all the way around the compass through S.
		if (rotateFromAngle - rotateToAngle > 180) {
			rotateToAngle += 360;
		} else if (rotateFromAngle - rotateToAngle < -180) {
			rotateToAngle -= 360;
		}

		const rotateFrom = `${rotateFromAngle} ${halfSize} ${halfSize}`;

		// Angle to rotate the indicator to
		const rotateTo = `${rotateToAngle} ${halfSize} ${halfSize}`;

		this.previousBearing = windBearing;

		const isCalm = Number(windSpeed) === 0;

		return (
			<svg width={size} height={size}>

				<g class={style.direction_labels}>

					<text x={halfSize}
					      y={margin - labelSpacing}
					      text-anchor="middle">
						N
					</text>

					<text x={size - margin + labelSpacing}
					      y={halfSize}
					      text-anchor="start"
					      dy="0.35em">
						E
					</text>

					<text x={halfSize}
					      y={halfSize + radius + labelSpacing}
					      text-anchor="middle"
					      dy="0.71em">
						S
					</text>

					<text x={margin - labelSpacing}
					      y={halfSize}
					      text-anchor="end"
					      dy="0.35em">
						W
					</text>

				</g>

				<circle class={style.outline}
				        cx={halfSize}
				        cy={halfSize}
				        r={radius} />

				<text class={style.current_speed}
				      x={halfSize}
				      y={halfSize}
				      text-anchor="middle"
				      dy="0.35em">
					{ windSpeed }
				</text>

				<g style={{ fillOpacity: isCalm ? 0 : 1, strokeOpacity: isCalm ? 0 : 1 }}>

					<path class={style.direction_arrow}
					      d={indicatorPath}
					      transform={`rotate(${rotateTo})`}>
						{
							this.browserSupportsAnimateTransform
								? <animateTransform ref={el => { this.animateTransformElement = el; }}
								                    attributeType="XML"
								                    attributeName="transform"
								                    type="rotate"
								                    begin="0s"
								                    dur="0.5s"
								                    from={rotateFrom}
								                    to={rotateTo}
								                    fill="freeze" />
								: null
						}
					</path>

				</g>

			</svg>

		);
	}

}

export default WindGauge;



// WEBPACK FOOTER //
// ./components/wind-gauge/index.js